// extracted by mini-css-extract-plugin
export default {"rating":"Ry-z","numberOfStars":"Sy-z","count":"Ty-z","barGraphSpacing":"Uy-z","barGraph":"Vy-z"};